import { Injectable } from '@angular/core';
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";
import { FareOptimisation, IRejectFareOptimisationRequestParams } from "libraries/service/booking/enums/fare-optimisation";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { EHosts } from "libraries/enums/EHosts";
import { FareMethodType } from "libraries/component/booking-information/components/booking-fare-optimisation-card/fare-method-type";
import { DummyCheckboxService } from "libraries/dummyCheckbox/dummyCheckbox.service";

@Injectable()
export class FareOptimisationResourceService {

    public fareOptimisationEnum: typeof FareOptimisation = FareOptimisation;

    constructor(
        private readonly apiResourceService: ApiResourceService,
        private readonly dummyCheckboxService: DummyCheckboxService
    ) {
    }

    public rejectFareOptimisation(body: IRejectFareOptimisationRequestParams): Observable<any> {
        return this.apiResourceService
            .postOne(
                this.apiResourceService.getApiUrl(this.fareOptimisationEnum.fareopt, this.fareOptimisationEnum.Reject),
                body
            )
            .pipe(
                shareReplay()
            );
    }

    public acceptOptimisation(syscode: string, host: EHosts, method: FareMethodType, priceQuotationTypeReference: string, priceStoredFareTypeReference: string): Observable<any> {
        return this.apiResourceService
            .postOne(
                this.apiResourceService.getApiUrl(this.fareOptimisationEnum.fareopt, this.fareOptimisationEnum.Accept),
                {
                    host,
                    syscode,
                    method,
                    dummy: this.dummyCheckboxService.isDummy,
                    priceQuotationTypeReference,
                    priceStoredFareTypeReference
                }
            )
            .pipe(
                shareReplay()
            );
    }
}
